<template>
<div class="search-helper-comp__table--format search-helper-table">
<table class="splitFourTds">
    <thead>
        <tr class="module-headerTr">
            <td colspan="3" class="td0" v-html="$t('searchHelperFormatView.header.td0')"></td>
            <td class="td1" v-html="$t('searchHelperFormatView.header.td1')"></td>
            <td class="td2" v-html="$t('searchHelperFormatView.header.td2')"></td>
            <td class="td3" v-html="$t('searchHelperFormatView.header.td3')"></td>
        </tr>
    </thead>
    <tbody>
        <tr class="module-cnTr">
            <td rowspan="5" class="td4" v-html="$t('searchHelperFormatView.cn.td4')"></td>
            <td colspan="2" class="td5" v-html="$t('searchHelperFormatView.cn.td5')"></td>
            <td class="td6" v-html="$t('searchHelperFormatView.cn.td6')"></td>
            <td class="td7" v-html="$t('searchHelperFormatView.cn.td7')"></td>
            <td class="td8" v-html="$t('searchHelperFormatView.cn.td8')"></td>
        </tr>
        <tr class="module-cnTr">
            <td rowspan="4" class="td9" v-html="$t('searchHelperFormatView.cn.td9')"></td>
            <td class="td10" v-html="$t('searchHelperFormatView.cn.td10')"></td>
            <td class="td11" v-html="$t('searchHelperFormatView.cn.td11')"></td>
            <td class="td12" v-html="$t('searchHelperFormatView.cn.td12')"></td>
            <td rowspan="4" class="td13" v-html="$t('searchHelperFormatView.cn.td13')"></td>
        </tr>
        <tr class="module-cnTr">
            <td class="td14" v-html="$t('searchHelperFormatView.cn.td14')"></td>
            <td class="td15" v-html="$t('searchHelperFormatView.cn.td15')"></td>
            <td class="td16" v-html="$t('searchHelperFormatView.cn.td16')"></td>
        </tr>
        <tr class="module-cnTr">
            <td class="td17" v-html="$t('searchHelperFormatView.cn.td17')"></td>
            <td class="td18" v-html="$t('searchHelperFormatView.cn.td18')"></td>
            <td class="td19" v-html="$t('searchHelperFormatView.cn.td19')"></td>
        </tr>
        <tr class="module-cnTr">
            <td class="td20" v-html="$t('searchHelperFormatView.cn.td20')"></td>
            <td class="td21" v-html="$t('searchHelperFormatView.cn.td21')"></td>
            <td class="td22" v-html="$t('searchHelperFormatView.cn.td22')"></td>
        </tr>
        <tr class="module-epTr">
            <td rowspan="2" class="td23" v-html="$t('searchHelperFormatView.ep.td23')"></td>
            <td colspan="2" class="td24" v-html="$t('searchHelperFormatView.ep.td24')"></td>
            <td class="td25" v-html="$t('searchHelperFormatView.ep.td25')"></td>
            <td class="td26" v-html="$t('searchHelperFormatView.ep.td26')"></td>
            <td class="td27" v-html="$t('searchHelperFormatView.ep.td27')"></td>
        </tr>
        <tr class="module-epTr">
            <td colspan="2" class="td28" v-html="$t('searchHelperFormatView.ep.td28')"></td>
            <td class="td29" v-html="$t('searchHelperFormatView.ep.td29')"></td>
            <td class="td30" v-html="$t('searchHelperFormatView.ep.td30')"></td>
            <td class="td31" v-html="$t('searchHelperFormatView.ep.td31')"></td>
        </tr>
        <tr class="module-woTr">
            <td rowspan="4" class="td32" v-html="$t('searchHelperFormatView.wo.td32')"></td>
            <td rowspan="2" class="td33" v-html="$t('searchHelperFormatView.wo.td33')"></td>
            <td class="td34" v-html="$t('searchHelperFormatView.wo.td34')"></td>
            <td class="td35" v-html="$t('searchHelperFormatView.wo.td35')"></td>
            <td class="td36" v-html="$t('searchHelperFormatView.wo.td36')"></td>
            <td rowspan="2" class="td37" v-html="$t('searchHelperFormatView.wo.td37')"></td>
        </tr>
        <tr class="module-woTr">
            <td class="td38" v-html="$t('searchHelperFormatView.wo.td38')"></td>
            <td class="td39" v-html="$t('searchHelperFormatView.wo.td39')"></td>
            <td class="td40" v-html="$t('searchHelperFormatView.wo.td40')"></td>
        </tr>
        <tr class="module-woTr">
            <td rowspan="2" class="td41" v-html="$t('searchHelperFormatView.wo.td41')"></td>
            <td class="td42" v-html="$t('searchHelperFormatView.wo.td42')"></td>
            <td class="td43" v-html="$t('searchHelperFormatView.wo.td43')"></td>
            <td class="td44" v-html="$t('searchHelperFormatView.wo.td44')"></td>
            <td rowspan="2" class="td45" v-html="$t('searchHelperFormatView.wo.td45')"></td>
        </tr>
        <tr class="module-woTr">
            <td class="td46" v-html="$t('searchHelperFormatView.wo.td46')"></td>
            <td class="td47" v-html="$t('searchHelperFormatView.wo.td47')"></td>
            <td class="td48" v-html="$t('searchHelperFormatView.wo.td48')"></td>
        </tr>
        <tr class="module-usTr">
            <td rowspan="2" class="td49" v-html="$t('searchHelperFormatView.us.td49')"></td>
            <td colspan="2" class="td50" v-html="$t('searchHelperFormatView.us.td50')"></td>
            <td class="td51" v-html="$t('searchHelperFormatView.us.td51')"></td>
            <td class="td52" v-html="$t('searchHelperFormatView.us.td52')"></td>
            <td class="td53" v-html="$t('searchHelperFormatView.us.td53')"></td>
        </tr>
        <tr class="module-usTr">
            <td colspan="2" class="td54" v-html="$t('searchHelperFormatView.us.td54')"></td>
            <td class="td55" v-html="$t('searchHelperFormatView.us.td55')"></td>
            <td class="td56" v-html="$t('searchHelperFormatView.us.td56')"></td>
            <td class="td57" v-html="$t('searchHelperFormatView.us.td57')"></td>
        </tr>
        <tr class="module-jpTr">
            <td rowspan="5" class="td58" v-html="$t('searchHelperFormatView.jp.td58')"></td>
            <td colspan="2" class="td59" v-html="$t('searchHelperFormatView.jp.td59')"></td>
            <td class="td60" v-html="$t('searchHelperFormatView.jp.td60')"></td>
            <td class="td61" v-html="$t('searchHelperFormatView.jp.td61')"></td>
            <td class="td62" v-html="$t('searchHelperFormatView.jp.td62')"></td>
        </tr>
        <tr class="module-jpTr">
            <td rowspan="4" class="td63" v-html="$t('searchHelperFormatView.jp.td63')"></td>
            <td class="td64" v-html="$t('searchHelperFormatView.jp.td64')"></td>
            <td class="td65" v-html="$t('searchHelperFormatView.jp.td65')"></td>
            <td class="td66" v-html="$t('searchHelperFormatView.jp.td66')"></td>
            <td rowspan="4" class="td67" v-html="$t('searchHelperFormatView.jp.td67')"></td>
        </tr>
        <tr class="module-jpTr">
            <td class="td68" v-html="$t('searchHelperFormatView.jp.td68')"></td>
            <td class="td69" v-html="$t('searchHelperFormatView.jp.td69')"></td>
            <td class="td70" v-html="$t('searchHelperFormatView.jp.td70')"></td>
        </tr>
        <tr class="module-jpTr">
            <td class="td71" v-html="$t('searchHelperFormatView.jp.td71')"></td>
            <td class="td72" v-html="$t('searchHelperFormatView.jp.td72')"></td>
            <td class="td73" v-html="$t('searchHelperFormatView.jp.td73')"></td>
        </tr>
        <tr class="module-jpTr">
            <td class="td74" v-html="$t('searchHelperFormatView.jp.td74')"></td>
            <td class="td75" v-html="$t('searchHelperFormatView.jp.td75')"></td>
            <td class="td76" v-html="$t('searchHelperFormatView.jp.td76')"></td>
        </tr>
        <tr class="module-krTr">
            <td rowspan="2" class="td77" v-html="$t('searchHelperFormatView.kr.td77')"></td>
            <td colspan="2" class="td78" v-html="$t('searchHelperFormatView.kr.td78')"></td>
            <td class="td79" v-html="$t('searchHelperFormatView.kr.td79')"></td>
            <td class="td80" v-html="$t('searchHelperFormatView.kr.td80')"></td>
            <td rowspan="2" class="td81" v-html="$t('searchHelperFormatView.kr.td81')"></td>
        </tr>
        <tr class="module-krTr">
            <td colspan="2" class="td82" v-html="$t('searchHelperFormatView.kr.td82')"></td>
            <td class="td83" v-html="$t('searchHelperFormatView.kr.td83')"></td>
            <td class="td84" v-html="$t('searchHelperFormatView.kr.td84')"></td>
        </tr>
        <tr class="module-deTr">
            <td rowspan="5" class="td85" v-html="$t('searchHelperFormatView.de.td85')"></td>
            <td colspan="2" class="td86" v-html="$t('searchHelperFormatView.de.td86')"></td>
            <td class="td87" v-html="$t('searchHelperFormatView.de.td87')"></td>
            <td class="td88" v-html="$t('searchHelperFormatView.de.td88')"></td>
            <td class="td89" v-html="$t('searchHelperFormatView.de.td89')"></td>
        </tr>
        <tr class="module-deTr">
            <td rowspan="4" class="td90" v-html="$t('searchHelperFormatView.de.td90')"></td>
            <td class="td91" v-html="$t('searchHelperFormatView.de.td91')"></td>
            <td class="td92" v-html="$t('searchHelperFormatView.de.td92')"></td>
            <td class="td93" v-html="$t('searchHelperFormatView.de.td93')"></td>
            <td rowspan="4" class="td94" v-html="$t('searchHelperFormatView.de.td94')"></td>
        </tr>
        <tr class="module-deTr">
            <td class="td95" v-html="$t('searchHelperFormatView.de.td95')"></td>
            <td class="td96" v-html="$t('searchHelperFormatView.de.td96')"></td>
            <td class="td97" v-html="$t('searchHelperFormatView.de.td97')"></td>
        </tr>
        <tr class="module-deTr">
            <td class="td98" v-html="$t('searchHelperFormatView.de.td98')"></td>
            <td class="td99" v-html="$t('searchHelperFormatView.de.td99')"></td>
            <td class="td100" v-html="$t('searchHelperFormatView.de.td100')"></td>
        </tr>
        <tr class="module-deTr">
            <td class="td101" v-html="$t('searchHelperFormatView.de.td101')"></td>
            <td class="td102" v-html="$t('searchHelperFormatView.de.td102')"></td>
            <td class="td103" v-html="$t('searchHelperFormatView.de.td103')"></td>
        </tr>
        <tr class="module-gbTr">
            <td rowspan="4" class="td104" v-html="$t('searchHelperFormatView.gb.td104')"></td>
            <td colspan="2" class="td105" v-html="$t('searchHelperFormatView.gb.td105')"></td>
            <td class="td106" v-html="$t('searchHelperFormatView.gb.td106')"></td>
            <td class="td107" v-html="$t('searchHelperFormatView.gb.td107')"></td>
            <td class="td108" v-html="$t('searchHelperFormatView.gb.td108')"></td>
        </tr>
        <tr class="module-gbTr">
            <td rowspan="3" class="td109" v-html="$t('searchHelperFormatView.gb.td109')"></td>
            <td class="td110" v-html="$t('searchHelperFormatView.gb.td110')"></td>
            <td class="td111" v-html="$t('searchHelperFormatView.gb.td111')"></td>
            <td class="td112" v-html="$t('searchHelperFormatView.gb.td112')"></td>
            <td rowspan="3" class="td113" v-html="$t('searchHelperFormatView.gb.td113')"></td>
        </tr>
        <tr class="module-gbTr">
            <td class="td114" v-html="$t('searchHelperFormatView.gb.td114')"></td>
            <td class="td115" v-html="$t('searchHelperFormatView.gb.td115')"></td>
            <td class="td116" v-html="$t('searchHelperFormatView.gb.td116')"></td>
        </tr>
        <tr class="module-gbTr">
            <td class="td117" v-html="$t('searchHelperFormatView.gb.td117')"></td>
            <td class="td118" v-html="$t('searchHelperFormatView.gb.td118')"></td>
            <td class="td119" v-html="$t('searchHelperFormatView.gb.td119')"></td>
        </tr>
        <tr class="module-frTr">
            <td rowspan="5" class="td120" v-html="$t('searchHelperFormatView.fr.td120')"></td>
            <td rowspan="3" class="td121" v-html="$t('searchHelperFormatView.fr.td121')"></td>
            <td class="td122" v-html="$t('searchHelperFormatView.fr.td122')"></td>
            <td class="td123" v-html="$t('searchHelperFormatView.fr.td123')"></td>
            <td class="td124" v-html="$t('searchHelperFormatView.fr.td124')"></td>
            <td class="td125" v-html="$t('searchHelperFormatView.fr.td125')"></td>
        </tr>
        <tr class="module-frTr">
            <td class="td126" v-html="$t('searchHelperFormatView.fr.td126')"></td>
            <td class="td127" v-html="$t('searchHelperFormatView.fr.td127')"></td>
            <td class="td128" v-html="$t('searchHelperFormatView.fr.td128')"></td>
            <td class="td129" v-html="$t('searchHelperFormatView.fr.td129')"></td>
        </tr>
        <tr class="module-frTr">
            <td class="td130" v-html="$t('searchHelperFormatView.fr.td130')"></td>
            <td class="td131" v-html="$t('searchHelperFormatView.fr.td131')"></td>
            <td class="td132" v-html="$t('searchHelperFormatView.fr.td132')"></td>
            <td class="td133" v-html="$t('searchHelperFormatView.fr.td133')"></td>
        </tr>
        <tr class="module-frTr">
            <td rowspan="2" class="td134" v-html="$t('searchHelperFormatView.fr.td134')"></td>
            <td class="td135" v-html="$t('searchHelperFormatView.fr.td135')"></td>
            <td class="td136" v-html="$t('searchHelperFormatView.fr.td136')"></td>
            <td class="td137" v-html="$t('searchHelperFormatView.fr.td137')"></td>
            <td rowspan="2" class="td138" v-html="$t('searchHelperFormatView.fr.td138')"></td>
        </tr>
        <tr class="module-frTr">
            <td class="td139" v-html="$t('searchHelperFormatView.fr.td139')"></td>
            <td class="td140" v-html="$t('searchHelperFormatView.fr.td140')"></td>
            <td class="td141" v-html="$t('searchHelperFormatView.fr.td141')"></td>
        </tr>
        <tr class="module-ruTr">
            <td rowspan="7" class="td142" v-html="$t('searchHelperFormatView.ru.td142')"></td>
            <td rowspan="3" class="td143" v-html="$t('searchHelperFormatView.ru.td143')"></td>
            <td class="td144" v-html="$t('searchHelperFormatView.ru.td144')"></td>
            <td class="td145" v-html="$t('searchHelperFormatView.ru.td145')"></td>
            <td class="td146" v-html="$t('searchHelperFormatView.ru.td146')"></td>
            <td rowspan="3" class="td147" v-html="$t('searchHelperFormatView.ru.td147')"></td>
        </tr>
        <tr class="module-ruTr">
            <td class="td148" v-html="$t('searchHelperFormatView.ru.td148')"></td>
            <td class="td149" v-html="$t('searchHelperFormatView.ru.td149')"></td>
            <td class="td150" v-html="$t('searchHelperFormatView.ru.td150')"></td>
        </tr>
        <tr class="module-ruTr">
            <td class="td151" v-html="$t('searchHelperFormatView.ru.td151')"></td>
            <td class="td152" v-html="$t('searchHelperFormatView.ru.td152')"></td>
            <td class="td153" v-html="$t('searchHelperFormatView.ru.td153')"></td>
        </tr>
        <tr class="module-ruTr">
            <td rowspan="4" class="td154" v-html="$t('searchHelperFormatView.ru.td154')"></td>
            <td class="td155" v-html="$t('searchHelperFormatView.ru.td155')"></td>
            <td class="td156" v-html="$t('searchHelperFormatView.ru.td156')"></td>
            <td class="td157" v-html="$t('searchHelperFormatView.ru.td157')"></td>
            <td rowspan="4" class="td158" v-html="$t('searchHelperFormatView.ru.td158')"></td>
        </tr>
        <tr class="module-ruTr">
            <td class="td159" v-html="$t('searchHelperFormatView.ru.td159')"></td>
            <td class="td160" v-html="$t('searchHelperFormatView.ru.td160')"></td>
            <td class="td161" v-html="$t('searchHelperFormatView.ru.td161')"></td>
        </tr>
        <tr class="module-ruTr">
            <td class="td162" v-html="$t('searchHelperFormatView.ru.td162')"></td>
            <td class="td163" v-html="$t('searchHelperFormatView.ru.td163')"></td>
            <td class="td164" v-html="$t('searchHelperFormatView.ru.td164')"></td>
        </tr>
        <tr class="module-ruTr">
            <td class="td165" v-html="$t('searchHelperFormatView.ru.td165')"></td>
            <td class="td166" v-html="$t('searchHelperFormatView.ru.td166')"></td>
            <td class="td167" v-html="$t('searchHelperFormatView.ru.td167')"></td>
        </tr>
        <tr class="module-chTr">
            <td rowspan="5" class="td168" v-html="$t('searchHelperFormatView.ch.td168')"></td>
            <td rowspan="2" class="td169" v-html="$t('searchHelperFormatView.ch.td169')"></td>
            <td class="td170" v-html="$t('searchHelperFormatView.ch.td170')"></td>
            <td class="td171" v-html="$t('searchHelperFormatView.ch.td171')"></td>
            <td class="td172" v-html="$t('searchHelperFormatView.ch.td172')"></td>
            <td class="td173" v-html="$t('searchHelperFormatView.ch.td173')"></td>
        </tr>
        <tr class="module-chTr">
            <td class="td174" v-html="$t('searchHelperFormatView.ch.td174')"></td>
            <td class="td175" v-html="$t('searchHelperFormatView.ch.td175')"></td>
            <td class="td176" v-html="$t('searchHelperFormatView.ch.td176')"></td>
            <td class="td177" v-html="$t('searchHelperFormatView.ch.td177')"></td>
        </tr>
        <tr class="module-chTr">
            <td rowspan="3" class="td178" v-html="$t('searchHelperFormatView.ch.td178')"></td>
            <td class="td179" v-html="$t('searchHelperFormatView.ch.td179')"></td>
            <td class="td180" v-html="$t('searchHelperFormatView.ch.td180')"></td>
            <td class="td181" v-html="$t('searchHelperFormatView.ch.td181')"></td>
            <td rowspan="3" class="td182" v-html="$t('searchHelperFormatView.ch.td182')"></td>
        </tr>
        <tr class="module-chTr">
            <td class="td183" v-html="$t('searchHelperFormatView.ch.td183')"></td>
            <td class="td184" v-html="$t('searchHelperFormatView.ch.td184')"></td>
            <td class="td185" v-html="$t('searchHelperFormatView.ch.td185')"></td>
        </tr>
        <tr class="module-chTr">
            <td class="td186" v-html="$t('searchHelperFormatView.ch.td186')"></td>
            <td class="td187" v-html="$t('searchHelperFormatView.ch.td187')"></td>
            <td class="td188" v-html="$t('searchHelperFormatView.ch.td188')"></td>
        </tr>
    </tbody>
</table>
</div>
</template>

<script>

export default {
    data() {
        return {
            language: this.$i18n.locale
        };
    },
    mounted() {
        this.$emit('update-nav-handler', []);
    }
};
</script>

<style lang="scss">
</style>
